import { render, staticRenderFns } from "./BtnAccept.vue?vue&type=template&id=354b71ec"
import script from "./BtnAccept.vue?vue&type=script&lang=js"
export * from "./BtnAccept.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports